import { render, staticRenderFns } from "./PatrocinioSemeia.vue?vue&type=template&id=5ed44b63&scoped=true"
import script from "./PatrocinioSemeia.vue?vue&type=script&lang=js"
export * from "./PatrocinioSemeia.vue?vue&type=script&lang=js"
import style0 from "./PatrocinioSemeia.vue?vue&type=style&index=0&id=5ed44b63&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ed44b63",
  null
  
)

export default component.exports